import React from "react";
import { FeatureModule } from "@/shared/types/routing";
import { ManageAppointmentsIcon } from "@/shared/ui/icons";

const ManageAppointments = React.lazy(() => import("./ManageAppointments"));
const AppointmentConfirmation = React.lazy(() => import("./AppointmentConfirmation"));

const ManageAppointmentsModule: FeatureModule = {
    name: "manage-appointments",
    routes: [
        {
            path: "/manage-appointments",
            element: <ManageAppointments />,
            meta: {
                label: "layout.sidebar.manageAppointments",
                icon: ManageAppointmentsIcon,
                showInSidebar: true,
                requiresAuth: true,
            },
        },
        {
            path: "/manage-appointments/appointment-confirmation",
            element: <AppointmentConfirmation />,
            meta: {
                label: "booking:steps.paymentConfirmation",
                showInSidebar: false,
                requiresAuth: true,
            },
        },
    ],
};

export default ManageAppointmentsModule;
